<template>
  <q-card class="col-3 self-center frosted q-mt-xl">
    <q-card-section>
      <div class="text-center text-h6">
        <q-icon
          class="q-mr-md q-mb-xs"
          name="mdi-hospital-building"
          color="red"
        ></q-icon
        >{{ updateCard.clinic }}
      </div>
    </q-card-section>
    <q-separator inset class="bg-grey-4" />
    <q-card-section>
      {{ t("maps.name") }}
      <span class="text-bold">{{ updateCard.doctor }}</span>
      <div class="q-pt-sm"></div>
      {{ t("maps.specialization") }}
      <span class="text-bold">{{ updateCard.specialization }}</span>
      <div class="q-pt-sm"></div>
      {{ t("maps.opened") }}
      <span class="text-bold">{{ updateCard.schedule }}</span>
      <div class="q-pt-sm"></div>
      {{ t("maps.address") }}
      <span class="text-bold">{{ updateCard.address }}</span>
      <div class="q-pt-sm"></div>
      {{ t("maps.phone") }}
      <span class="text-bold">{{ updateCard.phone }}</span>
    </q-card-section>
    <q-card-section class="q-mt-md">
      <q-card-actions vertical class="justify-center q-ml-sm">

        <q-btn
          push
          class="bg-blue-8"
          color="white"
          align="center"
          :label="t('maps.buttons.site-label')"
          icon="mdi-web"
        >
          <q-tooltip
            class="bg-blue-10"
            anchor="center right"
            self="center left"
            :offset="[10, 10]"
            >{{ t("maps.buttons.visit-site") }}
          </q-tooltip>
        </q-btn>
      </q-card-actions>
    </q-card-section>
  </q-card>
</template>

<script>
import { useI18n } from "vue-i18n";
import { store } from "../store/store";

export default {
  name: "MapCard",

  setup() {
    const { t } = useI18n({
      inheritLocale: true,
      useScope: "local",
    });

    return { t };
  },
  computed: {
    updateCard() {
      if (store.state.clinic === "-") {
        store.state.clinic = this.t("maps.unselected");
      }
      return {
        clinic: store.state.mapData.clinic,
        doctor: store.state.mapData.doctor,
        specialization: store.state.mapData.specialization,
        schedule: store.state.mapData.schedule,
        address: store.state.mapData.address,
        phone: store.state.mapData.phone,
      };
    },
  },
};
</script>
